import React, { Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";

export class GameRules extends Component {

    static propTypes = {
        pageType: PropTypes.string,

    };


    constructor(props) {
        super(props);

        this.state = {
            data: {},
            loading: true,

        };        
      
    }

    async populateGameRules() {
        const response = await fetch('v1/api/GameRules', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });
        const data = await response.json();
        this.setState({ data: data, loading: false });
       
        if (data != null && data.Status) {

            console.log(data);

        }

    }

    renderRules(dataList) {

        return (<ul class='list'>
            {this.renderRuleItem(dataList)}
        </ul>);
    }

    renderRuleItem(dataList) {
        return dataList?.map((item, idx) => { // here
            
            return (
                <>
                    <li>
                        <i class="bi bi-check-circle"></i> {item}.
                    </li>   
                </>
            );
        });
    }

    componentDidMount() {
      
        this.populateGameRules();
    }
    

    render() {

       // let renderCat = ((this.state.loading == false) ? this.renderAritsts(this.state.data) : '');
        if (this.state.data != null && this.state.data.data != null && this.state.data.data.length > 0) {
            return (
                <>
                    <section id="rules">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="marquee">
                                        <h5>Game Rules :</h5>
                                        {this.renderRules(this.state.data.data)}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </section>
                </>);
        } else {
            <>
                loading..
            </>
               
        }
    }
}
